import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-south-dakota-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./south-dakota-state-form.component.html",
  styleUrl: "./south-dakota-state-form.component.scss",
})
export class SouthDakotaStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
